import { createClient } from '@supabase/supabase-js';

// Get Supabase URL and key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY;

// Add error checking for environment variables
if (!supabaseUrl) {
  console.error('REACT_APP_SUPABASE_URL is not defined in environment variables');
  console.log('Available env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
}

if (!supabaseAnonKey) {
  console.error('REACT_APP_SUPABASE_KEY is not defined in environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey); 